import { getSentryInstance } from "./Sentry.utils";

// The `Sentry` value represents a shared singleton to be used by any Lyceum
// code that wants to use the Sentry JS SDK. For the sake of consistency, do
// *not* use `window.Sentry`, nor import from `@sentry/nextjs`. See more about
// our idiosyncratic Sentry configuration here:
// ../README.md#idiosyncratic-sentry-configuration

// The following line of code assumes that `setSentryInstance` has already been
// called elsewhere, during Sentry initialization. Otherwise, there will be no
// Sentry instance.
const Sentry = getSentryInstance();

export default Sentry;
